import { GridColumnMenuFilterUIProps } from "@progress/kendo-react-grid";
import { RadioButton, RadioButtonChangeEvent } from "@progress/kendo-react-inputs";
import styled from "styled-components";

export type CustomRadioButtonValueType = { label: string; value: any };

interface CustomRadioButtonProps extends GridColumnMenuFilterUIProps {
  values: Array<CustomRadioButtonValueType>;
}

export function CustomFilterUiRadioButton(props: CustomRadioButtonProps) {
  const onChange = (event: RadioButtonChangeEvent) => {
    const value =
      event.value === "null"
        ? null
        : event.value === "true"
        ? true
        : event.value === "false"
        ? false
        : event.value;
    const { firstFilterProps } = props;

    firstFilterProps.onChange({
      value,
      operator: "eq",
      syntheticEvent: event.syntheticEvent,
    });
  };

  const { firstFilterProps, values } = props;
  const { value } = firstFilterProps;

  return (
    <div>
      {values.map((val) => {
        return (
          <StyledDiv>
            <RadioButton
              id={`bool-${val.value}`}
              name="boolean"
              type="radio"
              value={val.value}
              checked={val.value === value}
              onChange={onChange}
              label={val.label}
            />
            <br />
          </StyledDiv>
        );
      })}
    </div>
  );
}

const StyledDiv = styled.div`
  padding-left: 5px;
  padding-bottom: 7px;
`;
